import { TOURS_HUB } from '../constants';

// One tours hub connection per catalogue load: each trip card has its own, the main page has another.
const tourConnectionKey = (tripId) => {
  const key = `${TOURS_HUB}:${tripId || 'tripSearch'}`;
  return key;
};

export default tourConnectionKey;
